var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(6.000000, 6.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.15789474,17.7894737 C5.60453575,15.2631579 7.95587553,14 10.2119141,14 C12.4679526,14 14.6780163,15.2631579 16.8421053,17.7894737",
    id: "Path-21"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10,
    cy: 9,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99825608,20 C15.2582943,20 20,15.2614695 20,9.99953479 C20,4.73760011 15.2582943,0 9.99825608,0 C4.73821786,0 0,4.73760011 0,9.99953479 C0,15.2614695 4.73821786,20 9.99825608,20 Z",
    id: "Oval"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.39c7b9fd71696535f885c1af8638658e.svg";
export { ForwardRef as ReactComponent };